import { render } from "./passwordConfirmModel.vue?vue&type=template&id=2b4d35dc"
import script from "./passwordConfirmModel.vue?vue&type=script&lang=js"
export * from "./passwordConfirmModel.vue?vue&type=script&lang=js"

import "./passwordConfirmModel.vue?vue&type=style&index=0&id=2b4d35dc&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__